// extracted by mini-css-extract-plugin
export default {"settings":"hrdYifYP7Lxol7LXOLXY","container":"biew2M2gFVzVe9GMsJ6w"};